export default __webpack_public_path__ + "static/Poppins-Bold-65dd7f95fbfc5d48846d315072c51e6a.woff2";